import i18n from '../../i18n';

const isString = (type) => typeof type === 'string';

const isHAWB = (type) => type === "HAWB";

const isHBL = (type) => type === "HBL";

const getTitleOfHouse = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.aereo.lista_HAWB');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.aereo.lista_HBL');
    }

    return "HOUSE";

}

const getBreadcrumbsOfHouse = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.dadosEmbarque.hawb');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.dadosEmbarque.hbl');
    }

    return "HOUSE";
}

const getLabelNumeroProcesso = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.numeroProcesso');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.numeroProcesso');
    }

    return "HOUSE";

}

const getLabelCliente = (type) => {
    
    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.cliente.label');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.cliente.label');
    }

    return i18n.t('com.muralis.qcx.cliente.label');
}

const getLabelConsignatario = (type) => {
      
    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.agenciamento.consignatario');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.agenciamento.consignatario');
    }

    return i18n.t('com.muralis.qcx.agenciamento.consignatario');
}

const getLabelServico = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.servico.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.servico.labelPlural');
    }

    return i18n.t('com.muralis.qcx.servico.labelPlural');

}

const getLabelTarifa = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.tarifa.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.tarifa.labelPlural');
    }

    return i18n.t('com.muralis.qcx.tarifa.labelPlural');

}

const getLabelTabelaFrete = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.tabelaFrete.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.tabelaFrete.labelPlural');
    }

    return i18n.t('com.muralis.qcx.tabelaFrete.labelPlural');

} 

const getLabelOrigem = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.origem');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.origem');
    }

    return i18n.t('com.muralis.qcx.origem');

} 

const getLabelDestino = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.transferencia.destino');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.transferencia.destino');
    }

    return i18n.t('com.muralis.qcx.transferencia.destino');

} 

const getLabelTipoEmbarque = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.tipoEmbarque.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.tipoEmbarque.labelPlural');
    }

    return i18n.t('com.muralis.qcx.tipoEmbarque.labelPlural');

} 

const getLabelCargaPerigosa = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.cargaPerigosa.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.cargaPerigosa.labelPlural');
    }

    return i18n.t('com.muralis.qcx.cargaPerigosa.labelPlural');

} 

const getLabelIncoterm = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.agenciamento.incoterm');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.agenciamento.incoterm');
    }

    return i18n.t('com.muralis.qcx.agenciamento.incoterm');

} 

const getLabelAgenteCarga = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.agenteCarga.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.armador.labelPlural');
    }

    return i18n.t('com.muralis.qcx.agenciamento.labelPlural');

} 

const getLabelAeroportoDesembarque = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.aeroportoDesembarque.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.portoDesembarque.labelPlural');
    }

    return i18n.t('com.muralis.qcx.aeroportoDesembarque.labelPlural');

} 

const getLabelCiaAerea = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.ciaAerea.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.embarcacao.label');
    }

    return i18n.t('com.muralis.qcx.ciaAerea.labelPlural');

} 

const getLabelNrVoo = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.nrVoo.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.nrviagem.labelSingular');
    }

    return i18n.t('com.muralis.qcx.nrVoo.labelPlural');

} 


const getLabelAeroportoEmbarque = (type) => {

    if(!isString(type)) {
        throw new Error('Argumento passado não é uma string !!');
    }

    if(isHAWB(type)) {
        return i18n.t('com.muralis.qcx.aeroportoEmbarque.labelPlural');
    }

    if(isHBL(type)) {
        return i18n.t('com.muralis.qcx.portoEmbarque.labelSingular');
    }

    return i18n.t('com.muralis.qcx.aeroportoEmbarque.labelPlural');

} 

export { 
    isHAWB,
    isHBL,
    getBreadcrumbsOfHouse,
    getTitleOfHouse,
    getLabelNumeroProcesso,
    getLabelCliente,
    getLabelConsignatario,
    getLabelServico,
    getLabelTarifa,
    getLabelTabelaFrete,
    getLabelOrigem,
    getLabelDestino,
    getLabelTipoEmbarque,
    getLabelCargaPerigosa,
    getLabelIncoterm,
    getLabelAgenteCarga,
    getLabelAeroportoDesembarque,
    getLabelCiaAerea,
    getLabelNrVoo,
    getLabelAeroportoEmbarque,
 }